import { Injectable } from '@angular/core';

/** Default dropdown configuration */
@Injectable()
export class BsDropdownConfig {
  /** default dropdown auto closing behavior */
  autoClose = true;
}



// WEBPACK FOOTER //
// ./~/angular-bootstrap-md/dropdown/dropdown.config.ts